<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="2" :offset="22">
					<!-- <el-button @click="add" size="mini">新建寄养</el-button> -->
				</el-col>
			</el-row>
		</div>
		<div style="margin:0 0px;">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="回访结果" prop="visitContent" width="100">
					<template slot-scope="props">
						<div>{{props.row.visitResult.name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="回访记录" prop="visitContent" >
				</el-table-column>
				<el-table-column label="回访类型" >
					<template slot-scope="props">
						<div>{{$public.getReturnVisitType(props.row.returnVisitType)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="回访时间" width="150">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.visitTime,'YYYY-MM-DD HH:mm:ss')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="回访人员" width="100">
					<template slot-scope="props">
						<div>{{props.row.visitUser.userName}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="操作">
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="seePet(props.row)">查看</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<page :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<bingliSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @close="submit_drawerJiyangPetSee"></bingliSee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import bingliSee from "../drawer/bingliSee.vue"
	export default {
		components:{page,bingliSee},
		data(){
			return{
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				// seePet
				drawerJiyangPetSee_state:false,
				curItem:{}
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		watch:{
			curPetInfo(){
				this.getTableData()
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			toBingliSee(row){
				this.$router.push({path:"/yiliao/bingliEdit?type=see&eid="+row.caseNumber})
			},
			seePet(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
			},
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 获取寄养列表
			getTableData() {
				let loading=this.$loading();
				let params = {
					"memberId": this.userInfo._id,
					"visitStatus": "",
					"visitUserId": "",
					"beginTime": 0,
					"endTime": 0,
					"returnVisitType": 0,
					"otherParam": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				// if(this.datetimerange&&this.datetimerange.length==2){
				// 	params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
				// 	params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				// }
				console.log(params)
				this.$http.post(process.env.VUE_APP_Url_8020+'/api/returnvisit/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:0 0 20px;box-sizing: border-box;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:8px 8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		
	}
}
</style>
